<template>
  <div class="site-template-item template-item">
    <div class="template-item__image">
      <img
        :src="imgSrc"
        :alt="item.title"
      />
    </div>
    <div class="template-item__content">
      <div class="template-item__title">{{ item.title }}</div>
      <div class="template-item__description description">
        <div class="description__text">{{ item.description }}</div>
      </div>
      <div class="template-item__button-bar">
        <button
          class="template-item__btn btn btn--black"
          @click="selectTemplateItem(item.id)"
        >
          <Preloader
            v-if="isLoading"
            :is-multiple="true"
          />
          <span v-else>Выбрать</span>
        </button>
        <button
          class="template-item__btn btn"
          @click="isPreviewModalOpen = true"
        >
          Посмотреть
        </button>
      </div>
    </div>
  </div>

  <Modal
    v-if="isPreviewModalOpen"
    :is-sticky-header="true"
    @close="isPreviewModalOpen = false"
  >
    <template #header>
      <SiteTemplatePreviewHeader
        :item="item"
        :is-loading="isLoading"
        :selected-media-type="selectedMediaType"
        @select="selectTemplateItem(item.id)"
        @close="isPreviewModalOpen = false"
        @select-media-type="selectMediaType"
      />
    </template>
    <template #default>
      <SiteTemplatePreview
        :item="item"
        :is-loading="isLoading"
        :selected-media-type="selectedMediaType"
        @select="selectTemplateItem(item.id)"
        @close="isPreviewModalOpen = false"
      />
    </template>
  </Modal>

  <Teleport
    v-if="isLoading"
    to="#overlay"
  >
    <div class="site-template-item-overlay" />
  </Teleport>
</template>

<script setup lang="ts">
import { EMediaTypes } from '@/types';
import { Modal } from '@/shared/ui/modal';
import { type Types, useSiteTemplates } from '@/entities/site-template';
import SiteTemplatePreview from './SiteTemplatePreview/SiteTemplatePreview.vue';
import { Preloader } from '@/shared/ui/preloader';
import SiteTemplatePreviewHeader from './SiteTemplatePreview/SiteTemplatePreviewHeader.vue';

const props = defineProps({
  item: {
    type: Object as PropType<Types.ISiteTemplate>,
    default: () => {},
  },
});

const { selectTemplate } = useSiteTemplates();
const imgSrc = computed(() => {
  return new URL(`${props.item.imageUrl}`, import.meta.url).href;
});

const isPreviewModalOpen = ref(false);
const isLoading = ref(false);
const selectedMediaType = ref(EMediaTypes.desktop);

const selectTemplateItem = async (itemId: string) => {
  isLoading.value = true;
  await selectTemplate(itemId);
  isLoading.value = false;
};

const selectMediaType = (newMediaType: EMediaTypes) => {
  selectedMediaType.value = newMediaType;
};
</script>

<style lang="scss" scoped>
.site-template-item-overlay {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1500;
  background-color: rgba(255, 255, 255, 0.5);
}

.site-template-item {
  width: 350px;
  height: 548px;
  background-color: #eee;
}

.template-item {
  &__image {
    width: 100%;
    height: 300px;
  }

  &__content {
    padding: 24px 40px;
    overflow: hidden;
    position: relative;
    background: #eee;
    display: flex;
    flex-direction: column;
    height: 200px;
  }

  &__title,
  &__description {
    font-family: 'Opensans';
    color: black;
  }

  &__title {
    font-size: 20px;
    line-height: 24px;
    font-weight: 400;
  }

  &__description {
    font-size: 16px;
    line-height: 22px;
    font-weight: 300;
    margin-top: 12px;
    flex: 117px;
    position: relative;
    overflow: hidden;

    &:after {
      content: '';
      position: absolute;
      bottom: 46px;
      left: 0;
      height: 41px;
      width: 100%;
      background-image: linear-gradient(1deg, #eee 15%, rgba(255, 255, 255, 0));
    }
  }

  &__button-bar {
    margin-top: 30px;
    display: flex;
    gap: 16px;
    z-index: 10;
    position: absolute;
    background: #eee;
    bottom: 24px;
    left: 40px;
    right: 40px;
  }

  &__btn {
    flex: 1;
  }
}
</style>
